export default __webpack_public_path__ + "static/media/0049.9855472c.jpg";